import { render, staticRenderFns } from "./StartupRequestModification.vue?vue&type=template&id=508a2aaf"
import script from "./StartupRequestModification.vue?vue&type=script&lang=js"
export * from "./StartupRequestModification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports